module.exports = __webpack_public_path__ + "img/11.b7f67e4f.png";